import React from 'react';
import { ModalBase } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import errorImage from '@panel/commons/assets/img/general_error_modal.svg';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Img = styled.div`
  background-image: url(${errorImage});
  width: 176px;
  height: 140px;
  margin-top: 40px;
`;

const Title = styled.h4`
  height: 26px;
  margin: 14px 0px 4px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: ${select('black')};
`;

const Description = styled.p`
  width: 356px;
  height: 52px;
  margin-bottom: 36px;
  font-size: 16px;
  color: ${select('darkGray')};
  text-align: center;
  white-space: break-spaces;
`;

const TryAgain = styled.button`
  width: 176px;
  height: 48px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: ${select('white')};
  background-color: ${getColor('primary')};
  cursor: pointer;
`;

function GeneralError({ onClose, openModal, handleClick }) {
  const { t } = useTranslation();
  return (
    <ModalBase openModal={openModal} onClose={onClose} width='400px' height='376px'>
      <Container data-repa='Modals-generalError-container'>
        <Img data-repa='Modals-generalError-container-img' />
        <Title data-repa='Modals-generalError-container-title'>{t('publisher.modal.generalError.title')}</Title>
        <Description data-repa='Modals-generalError-container-description'>
          {t('publisher.modal.generalError.description')}
        </Description>
        <TryAgain data-repa='Modals-generalError-container-CTA' type='button' onClick={handleClick}>
          {t('publisher.modal.generalError.button')}
        </TryAgain>
      </Container>
    </ModalBase>
  );
}

export { GeneralError };
